import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';
import errorHandler from 'src/gql/errorHandler';
import i18n from 'src/i18n';
import { removeCurrentWorkspace } from '../slices/currentWorkspace';
import { removeUser } from '../slices/user';
import {
  removeEmailedInvitation,
  resetInvitations,
} from '../slices/invitations';
import { setWorkspaces } from '../slices/workspaces';
import history from 'src/routes/history';
import { getCurrentUser } from './user';

export const signUp = createAsyncThunk(
  'authentication/signUp',
  async (payload) => {
    const {
      data,
      formActions: { setErrors, setSubmitting, setRegistrationComplete },
    } = payload;

    try {
      delete data.acceptTerms;
      delete data.confirmPassword;
      // yield put(signUpRequest());
      await api.auth.signUp({ data });
      // yield put(finishSignUpRequest());
      setRegistrationComplete(true);
    } catch (error) {
      setSubmitting(false);
      if (error.message === 'GraphQL error: emailExist') {
        setErrors({ afterSubmit: i18n.t('EMAIL_ALREADY_EXIST_ERROR') });
      } else {
        setErrors({ afterSubmit: i18n.t('GENERAL_ERROR') });
      }
      // yield put(errorSignUpRequest());
    }
  }
);

export const signIn = createAsyncThunk(
  'authentication/signIn',
  async (payload, { dispatch }) => {
    const {
      data,
      formActions: { setErrors, setSubmitting },
    } = payload;

    try {
      // yield put(signInRequest());
      const response = await api.auth.signIn({ data });

      if (response?.data?.signIn?.token) {
        const {
          data: {
            signIn: { token },
          },
        } = response;

        localStorage.setItem('token', token);
        dispatch(getCurrentUser());
      } else {
        throw new Error('Server error');
      }
    } catch (error) {
      console.log(errorHandler(error));
      setSubmitting(false);
      setErrors({ afterSubmit: errorHandler(error) });
    }
  }
);

export const signOut = createAsyncThunk(
  'authentication/signOut',
  async (a, { dispatch }) => {
    try {
      const response = await api.auth.signOut();
      if (response?.data?.signOut) {
        localStorage.removeItem('token');
        dispatch(removeUser());
        dispatch(setWorkspaces([]));
        dispatch(removeEmailedInvitation());
        dispatch(removeCurrentWorkspace());
        dispatch(resetInvitations());
        // yield put(finishGettingUserWorkspace());
        // yield put(finishSignOut());
        history.push('/');
      } else {
        throw new Error('Server error');
      }
    } catch (error) {
      console.log(error);
      // eslint-disable-next-line no-console
      console.log(errorHandler(error));
      history.push('/');
      // yield put(finishSignOut());
    }
  }
);

export const forgotPassword = createAsyncThunk(
  'authentication/forgotPassword',
  async (payload) => {
    const {
      email,
      formActions: { setErrors, setSubmitting, setSent },
    } = payload;

    try {
      await api.auth.forgotPassword({ email });
      // await dispatch(finishForgotPassword());
      setSubmitting(false);
      setSent(true);
    } catch (error) {
      setSubmitting(false);
      setErrors({ afterSubmit: i18n.t('GENERAL_ERROR') });
      // await dispatch(finishForgotPassword());
    }
  }
);
